// extracted by mini-css-extract-plugin
export default {"wrap":"button_wrap__7pU6c","copy":"button_copy__s57Ek","submit":"button_submit__UMmr5","green":"button_green__VWAmz","black":"button_black__AS-WD","white":"button_white__tpEGi"};